import { Banner } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { CheckInConfigurationValue } from '@mews-commander/data-access';
import { CheckInFieldsValues } from './types';
import { FieldData } from './sections';
import { TabItemValue } from './CheckInTabs/enums';

interface WarningMessageProps {
    visibilityData: CheckInFieldsValues;
    section: FieldData[];
    hasNewTypeDocumentCopyEnabled?: boolean;
    activeTabValue: TabItemValue;
}

export const WarningMessage = ({
    visibilityData,
    section,
    hasNewTypeDocumentCopyEnabled,
    activeTabValue,
}: WarningMessageProps) => {
    if (!hasNewTypeDocumentCopyEnabled) {
        return null;
    }

    if (activeTabValue !== TabItemValue.GuestVerification) {
        return null;
    }

    const hasRelevantField = section.some((field) => {
        const fieldValue = visibilityData[field.type];
        return Object.values(fieldValue).some(
            (value) => value === CheckInConfigurationValue.Required || value === CheckInConfigurationValue.Optional
        );
    });

    if (hasRelevantField) {
        return (
            <Banner
                variant="warning"
                primaryText={<LocalizedText textKey={TextKey.VerificationMessageRequiredTitle} />}
                secondaryText={<LocalizedText textKey={TextKey.VerificationMessageRequiredDescription} />}
            />
        );
    }

    return null;
};
